import { Alert } from '@creditornot/cb-alert';
import React from 'react';

import { usePluralization } from 'common/hooks';

import { SELF_DELIVERY_VENUES_NOT_ALLOWED } from '../../constants';
import { VenuesValidationError } from '../../types';

export const VenuesErrorWarning = ({ error, className }: { error: VenuesValidationError; className?: string }) => {
  const { FormattedPluralMessage } = usePluralization();
  const { id, reason } =
    error.reason === SELF_DELIVERY_VENUES_NOT_ALLOWED
      ? { id: 'campaigns.form.venues.unsupported-campaign-self-delivery-venues-title', reason: null }
      : { id: 'campaigns.form.venues.unsupported-campaign-venues-title', reason: error.reason };

  return (
    <Alert variant="warning" size="small" className={className}>
      <FormattedPluralMessage id={id} count={error.venueIds.length} />
      {reason && <br />}
      {reason}
    </Alert>
  );
};
